module.exports = __webpack_public_path__ + "img/ico-tw.aab58cd7.svg";